<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Empresas
    v-layout(align-start='', justify-start='', row='', fill-height='')
        v-flex(xs12)
            v-card(color='', style="border-radius:5px;background-color: black;height:80px")
                v-card-title.justify-center
                    img(src='../assets/logo3.png', with='50' ,height='50')
            v-card(color='', style="border-radius:5px;background-color: #d6d6d6")
                v-card-title(style="padding: 7px;").justify-center
                    span.black--text  Dashboard
    v-flex(xs12 sm12 md12 style='margin-top:40px;text-align:center;')
      h2 Fecha de vencimiento: {{empresa.fechaCorte | moment('DD/MM/YYYY')}}
    v-flex(xs12 sm12 md12 style='margin-top:40px;')
        v-layout(wrap align-center justify-center)
            v-flex(xs12 sm4 style='padding: 10px;')
                v-card(style='border-radius: 10px;')
                    div(style='text-align:center;background: black;border-radius: 10px 10px 0px 0px;')
                        span(style='font-size: 35px;color:white;') {{empresa.nombre}}
                    div(style='text-align:center;display:flex;flex-direction:column;padding:5px;')
                       span(style='font-size: 28px;') Total: {{empresa.mensajesA}}
                       span(style='font-size: 28px;') Enviados: {{empresa.mensajes}}
                        

</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mDashboard",
  data: () => ({
    ruta: server + ":" + port,
    empresa: {}
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      Api.get("empresa/" + this.$store.state.mensajitoEmpUser._id).then(res => {
        this.empresa = res.data;
      });
    }
  }
};
</script>
